import React, { useState, useEffect } from "react";
import "./LoadSlider.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Input } from "reactstrap";

const DEFAULT_MAX = 12;

const LoadSlider = ({
  onChange,
  value,
  lightText,
  title = "Quantidade",
  max,
  step: stepProp,
  textColor,
}) => {
  const step = stepProp || 0.5;
  const minValue = step;
  const color = textColor || (lightText ? "#fff" : "#2E384D");
  const inputColor = textColor || "#D3D3D3";
  const [maxValue, setMaxValue] = useState(DEFAULT_MAX);

  const effectiveValue = value || minValue;

  const handleInputChange = (e) => {
    const newValue = Math.trunc(parseFloat(e.target.value) * 10) / 10;
    if (newValue >= minValue && newValue <= maxValue) {
      onChange(newValue);
    } else if (newValue < minValue) {
      onChange(minValue);
    } else if (newValue > maxValue) {
      onChange(maxValue);
    } else {
      onChange(minValue);
    }
  };

  useEffect(() => {
    if (max) {
      setMaxValue(max);
    }
  }, [max]);

  return (
    <div className="load-slider-container">
      <div className="load-slider-info">
        <h3 style={{ color }}>{title}</h3>
        <div
          style={{
            display: "inline-flex",
            alignItems: "right",
            justifyContent: "center",
            color: "#D3D3D3",
            cursor: "default",
          }}
        >
          <Input
            value={parseFloat(effectiveValue).toFixed(1)}
            className="number-input"
            type="number"
            inputMode="decimal"
            onChange={handleInputChange}
            min={0.5}
            max={maxValue}
            style={{
              width: "60px",
              height: "40px",
              display: "block",
              textAlign: "right",
              align: "right",
              backgroundColor: "transparent",
              color: inputColor,
              fontSize: "20px",
              fontWeight: "bold",
              border: "none",
              paddingRight: "5px",
              cursor: "default",
            }}
          />
          <b
            style={{
              paddingTop: "12px",
              paddingLeft: "2px",
              color: inputColor,
            }}
          >
            m³
          </b>
        </div>
      </div>

      <Slider
        onChange={onChange}
        value={parseFloat(effectiveValue).toFixed(1)}
        min={minValue}
        max={maxValue}
        step={step}
        style={{ marginTop: "10px", color: "#1D84C6" }}
      />
    </div>
  );
};

export default LoadSlider;
